import React, { useContext, useState, useEffect, useRef } from 'react';
import { AccountListContext } from '../../../context/AccountListContext';
import api from '../../../services/api';
import { truncateDescription, getUserStatsObject, recordActivity, getUrlDetailsObj, numberWithCommas } from '../../../services/commonService';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import Alert from '../../HtmlElements/Alert';
import Autocomplete from '../../HtmlElements/Autocomplete';
import AllAccountsTileView from './AllAccountsTileView';
import { Link, useLocation, useParams } from 'react-router-dom';
import AllAccountsTableView from './AllAccountsTableView';
import { useUser } from '../../../context/UserContext';
import * as FeatherIcon from 'react-feather';
import MessageDialog from '../../HtmlElements/MessageDialog';
import { useDispatch } from 'react-redux';
import { resetAllAccDepen } from '../../../store/features/actions/commonActions';
import axios from "axios";
import { API_BASE_URL } from '../../../config/apiConfig';
import { fetchUserDetails } from '../../../services/authService';
import GenericTableSkeleton from '../skeletons/tableSkeleton/genericTableSkeleton';
import iq_api_v2 from '../../../services/iqApiV2';
import { useConfig } from '../../../context/AppConfigContext';
import Multiselect from 'multiselect-react-dropdown';
import Select from "react-select";
import AdditionalWebsitesInputElem from './AdditionalWebsitesInputElem';

const apiForFile = axios.create({
    baseURL: API_BASE_URL,
});

apiForFile.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${token}`,
            };
        }

        if (config.data instanceof FormData) {
            if (config.headers && config.headers['Content-Type']) {
                delete config.headers['Content-Type'];
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

apiForFile.defaults.responseType = 'blob';

export default function AllAccounts({setShowMoreModal}) {

    const {appConfig} = useConfig();

    const dispatch = useDispatch();
    const {  updateMyReportContext, loading, allAccounts } = useContext(AccountListContext);
    const [show, setShow] = useState(false);
    const [all_accounts_view, setAllAccountsView] = useState('table'); // grid || table
    var currentUrl = useLocation().pathname;
    const pageParsedData = getUrlDetailsObj(useLocation, useParams);
    const [successMessage, setSuccessMessage] = useState('');
    const [showAddAccModal, setShowAddAccModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loader4AddingAccount, setLoader4AddingAccount] = useState(false);
    const [error, setError] = useState('');
    const [addApiError, setApiError] = useState('');
    const [newClientName, setNewClientName] = useState('');
    const [newClientCode, setNewClientCode] = useState('');
    const [newAccountName, setNewAccountName] = useState('');
    const [newAccountCode, setNewAccountCode] = useState('');
    const [newAccountWebsite, setNewAccountWebsite] = useState('');
    const [targetedRegions, setTargetedRegions] = useState({
        "id": "ALL",
        "name": "All"
    });
    const [isWebisteFieldDisabled, setIsWebisteFieldDisabled] = useState(false);
    const [numberOfContacts, setNumberOfContacts] = useState(0)

    const { user, setMyAllFavourites, setUserAssingedAccounts } = useUser();
    const [userCurrentRole, setUserCurrentRole] = useState(user?.role_key || '');
    const [messageInfo, setMessageInfo] = useState({})
    const [searchTerm, setSearchTerm] = useState('');
    const [accountMemoryFiles, setAccountMemoryFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [additionalWebsites, setAdditionalWebisites] = useState([])

    // const regionsList = appConfig?.globalRegionList || [];
    let regions_list_tmp = (appConfig?.globalRegionList || []).map(contact => ({
        id: contact.Code,
        name: contact.Name,
    }));
    const regionsList = regions_list_tmp;

    // useEffect(() => {
    //     if(appConfig?.globalRegionList){
    //         console.log("regionsList[0] : ", regionsList[0])
    //         handleRegionChange(appConfig?.globalRegionList[0])    
    //     }
    // }, [appConfig?.globalRegionList])

    useEffect(() => {
          dispatch(resetAllAccDepen())
    }, [])


    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files).map(file => ({
            file,
            error: null
        }));
        setAccountMemoryFiles(prevFiles => [...prevFiles, ...selectedFiles]);
    };

    const handleRemoveFile = (index) => {
        setAccountMemoryFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    useEffect(() => {
        setNewClientName(user?.company_name);
        setNewClientCode(user?.company_id);
        setUserCurrentRole(user?.role_key);

        updateMyReportContext()
    }, [user]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const modalAddAccount = () => {
        setApiError('')
        setShowAddAccModal(true);
    };

    const handleWebsiteChange = (e) => {
        const { name, value} = e.target;
        setNewAccountWebsite(value)
    }

    const handleRegionChange = (selected_regions) => {
        // const { name, value} = e.target;
        // console.log(name, value)
        // console.log("selected_regions : ", selected_regions)
        setTargetedRegions(selected_regions)
        // console.log("handleRegionChange SS : ", selected_regions)
    }

    const handleAutoCompleteChange = (e) => {
        const { name, value, code, selected_data } = e.target;
        if(name === "account_name"){
          setNewAccountName(value)
          setNewAccountCode(code?.toString())
          setNewAccountWebsite(selected_data?.webpage || "")
          setIsWebisteFieldDisabled(selected_data?.webpage ? true : false)

        }
    }

    useEffect(() => {

        const fetchContactCount = async() => {
            try {

                let all_domains = [];
                if (newAccountWebsite) {
                    all_domains.push(newAccountWebsite);
                }

                if (Array.isArray(additionalWebsites)) {
                    all_domains = [...all_domains, ...additionalWebsites];
                }

                let post_params = {
                    "domain": all_domains, // website selected from below dropdown
                    "person_seniorities": ["owner", "founder", "c_suite", "partner", "vp", "head", "director"],
                    "per_page": 1,
                    // 'additional_websites': additionalWebsites
                }

                if(targetedRegions?.name.toLowerCase() !== "all"){
                    post_params.person_locations = [targetedRegions?.name]
                }

                const response = await iq_api_v2.post(
                    "contact/contact_filters",
                    post_params,
                    {
                        headers: {
                        "Content-Type": "application/json",
                        },
                    }
                );

                setNumberOfContacts(response?.data?.pagination?.total_entries || 0)
                    
            }catch (error) {
                setNumberOfContacts(0)
            }
        }

        const handler = setTimeout(() => {
            if (newAccountWebsite) {
                fetchContactCount();
            }
        }, 600);

        // Cleanup timeout on dependency change
        return () => {
            clearTimeout(handler);
        };

    }, [newAccountWebsite, targetedRegions, additionalWebsites]);

    const handleAddAccount = async () => {

        try {
            setLoader4AddingAccount(true);
            if(accountMemoryFiles.length > 0){
                try{
                    const validate_response = await api.post('/accounts/validate_account', {
                        account_name: newAccountName?.trim(),
                        account_code: newAccountCode?.trim(),
                        client_name: newClientName?.trim(),
                        client_code: newClientCode?.trim(),
                        webpage: newAccountWebsite.trim(),
                        targeted_regions: targetedRegions,
                        'additional_websites': additionalWebsites
                    });
                    if (validate_response.data.status !== 200) {
                        setApiError(validate_response.data.result.message || 'An error occurred while saving the company.');

                        setLoader4AddingAccount(false);
                        setTimeout(() => {
                            setApiError("");
                        }, 5000)
                        setLoader(false);

                        return false;
                    }
                } catch (error) {
                    setApiError(error?.response?.data?.error || 'An error occurred while saving the company.');
                    setLoader4AddingAccount(false);
                    setTimeout(() => {
                        setApiError("");
                    }, 5000)
                    setLoader(false);
                    return false;
                }

                const uploadResponseFiles = []

                // For Account level Memory Generation

                // Upload Memory Documents
                var is_error_in_uploading = false;
                for (let i = 0; i < accountMemoryFiles.length; i++) {
                    const { file } = accountMemoryFiles[i];
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('client', newClientName?.trim());
                    formData.append('account', newAccountName?.trim());
                    formData.append('is_admin', 1);
                    formData.append('document_type', 'memory');
                    formData.append('user_id', user?.id);

                    try {
                        const response = await iq_api_v2.post('/documents/upload_file', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        });
                        console.log("record_id:", response.data.result.record_id);
                        uploadResponseFiles.push(response.data.result.record_id);
                    }catch (error) {
                        // console.error(`Error uploading file ${file.name}:`, error);

                        is_error_in_uploading = true;

                        // Update the specific file's error
                        setAccountMemoryFiles(prevFiles => {
                            const updated = [...prevFiles];
                            updated[i] = { ...updated[i], error: 'Failed to upload. '+error?.response?.data?.detail };
                            return updated;
                        });
                    }
                }

                if(is_error_in_uploading){
                    setLoader4AddingAccount(false);
                    return false;
                }
                // End: Upload Memory Documents

                // Build Memory for upload docs
                const formData2 = new FormData();
                formData2.append('prompt', `Create memory for the given document in the context of '${newClientName?.trim()}' and '${newAccountName?.trim()}' to enable opportunity creation.`);
                formData2.append('client', newClientName?.trim());
                formData2.append('account', newAccountName?.trim());
                formData2.append('file_ids', uploadResponseFiles.join(','))
                formData2.append('is_admin', 1);
                formData2.append('memory_type', 'client_account');

                const response = await iq_api_v2.post('/build_memory/create_memory', formData2, {
                    headers: {'Content-Type': 'multipart/form-data'},
                });
                // End: Build Memory for upload docs
            }
            // End: For Account level Memory Generation

            // console.log("uploadResponse :: ", uploadResponseFiles)

          const response = await api.post('/accounts/add_account', {
            account_name: newAccountName?.trim(),
            account_code: newAccountCode?.trim(),
            client_name: newClientName?.trim(),
            client_code: newClientCode?.trim(),
            webpage: newAccountWebsite.trim(),
            'additional_websites': additionalWebsites,
            targeted_regions: targetedRegions,
            add_account_to_v2: true
          });

          if (response.data.status === 201 || response.data.status === 200) {

            var assigned_accounts = user?.assigned_accounts ? [...user.assigned_accounts] : [];
            assigned_accounts.push(newAccountCode?.trim() || '')
            setUserAssingedAccounts(assigned_accounts)
            
            // await updateMyReportContext();
            handleAddAccClose();
            
            setMessageInfo({
                message_type: 'success',
                message: 'Account request has been sent successfully.',
            });

          }else{
            setApiError(response.data.result.message || 'An error occurred while saving the company.');
          }
          setLoader4AddingAccount(false);

        } catch (error) {

          if (error.response) {
            const errors = error.response.data?.result?.errors || [];

            if (Array.isArray(errors) && errors.length > 0) {
              const messages = errors.map(err => err.message).join('\n');
              setApiError(messages || 'Failed to add account.');
              
            } else {
              const fallback = error.response.data?.message || "Something went wrong.";
              setApiError(fallback || 'Failed to add account.');
            }
          } else if (error.request) {
            // The request was made but no response was received
            console.error("No response from server", error.request);
            setApiError("No response from server. Please check your network.");
          } else {
            // Something happened in setting up the request
            console.error("Error", error.message);
            setApiError("Error : " + error.message);
          }
          setLoader4AddingAccount(false);
        }
        setTimeout(() => {
          setApiError("");
        }, 5000)
        setLoader(false);
    };

    const handleAddAccClose = () => {
        setShowAddAccModal(false);
        setNewAccountName('');
        setNewAccountCode('');
        setNewAccountWebsite("")
        setAccountMemoryFiles([])
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setApiError('')
    };

    const changeAccountView = (view_type) => {
        let type = (view_type == 'grid') ? "tile_view" : "table_view";
        const userStat = getUserStatsObject("All Companies", type, "Page Source: Companies", currentUrl);
        userStat.url_details = pageParsedData;
        recordActivity(userStat);
        setAllAccountsView(view_type);
    }

    const hideMessageDialog = () => {
        setMessageInfo({});
    };

    // ++++++++++++++++++++++++++++++++++

    const handleAccountPlanDownload = async (account_code, client_code) => {
        try {
            const formData = new FormData();
            formData.append("account_code", account_code);
            formData.append("client_code", client_code);

            const response = await apiForFile.post(
                "/accounts/downloadAccountPlan",
                formData
            );

            const contentDisposition = response.headers['content-disposition'];
            let filename = "account_plan.xlsx";

            if (contentDisposition) {
                const filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/gi;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches && matches[1]) {
                    filename = matches[1]
                        .replace(/^utf-8''/i, '')
                        .replace(/%20/g, ' ');
                }
            }

            const contentType = response.headers['content-type'];
            let blobType = contentType;

            if (!blobType || blobType === 'application/octet-stream') {
                const ext = filename.split('.').pop().toLowerCase();
                blobType = {
                    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    xls: 'application/vnd.ms-excel',
                    pdf: 'application/pdf',
                }[ext] || 'application/octet-stream';
            }

            const blob = new Blob([response.data], { type: blobType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            // handleApiError(error, "Failed to download file");
        }
    };

    const handleSearch = (e) => {
        // console.log("SEARCH TERM: "+e.target.value);
        setSearchTerm(e.target.value);
    }
    // ++++++++++++++++++++++++++++++++++

    return (
        <div className='all_acccounts_wrapper' style={{
            backgroundColor: "#ffffff",
            padding: "20px",
            maxWidth:'99%',
            borderRadius: "12px",
            minHeight: "100vh"
        }}>
        {successMessage && <Alert type="success" message={successMessage} />}

        {/* {loading && <ScreenLoader/>} */}

        <MessageDialog
        show={messageInfo?.message}
        handleClose={hideMessageDialog}
        messageInfo={messageInfo} />

        {error && <Alert type="danger" message={error} />}

        {loading == false &&
            <div className="all_acccounts_block">
                <h5 className="all_acccounts_head">
                <FeatherIcon.Briefcase className='comp_icon' />
                    <span style={{'paddingRight': '5px'}}>All Accounts</span> 
                    <div className='pl-3 circle_ready'>
                        <div id="outer-circle">
                            <div id="inner-circle">
                            </div>
                        </div>
                    </div>
                </h5>
                <div className='d-flex toggle_block'>

                    <div className='filter_btn_block'>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            style={{
                                width: "350px",
                                height: "32px",
                                padding: "8px 4px 8px 12px",
                                border: "0.5px solid #42464847",
                                backgroundColor: "#FFFFFF",
                                fontSize: "12.5px",
                                lineHeight: "15.63px",
                                fontWeight: "500",
                                color: "#9595A1"
                            }}
                            value={searchTerm}
                            onChange={(e) => handleSearch(e)}
                        />
                    </div>
                    <div className='toggle_list_tableview mr-2'>
                        <Link className={`table_view ${all_accounts_view === 'table' ? 'active' : ''}`}
                            style={{
                                fontSize: "12px",
                                lineHeight: "15px",
                                textDecoration: "none",
                                padding: "7px 12px 7px 12px",
                                width: "56px",
                                height: "27px",
                                radius: "7px",

                            }}
                            onClick={()=> changeAccountView('table')}
                            >
                            {/* <img src='/img/icons/table_grey.png' alt="image" className='filter_image' width=""/> */}
                            Table
                        </Link>
                        <Link className={`grid_view ${all_accounts_view === 'grid' ? 'active' : ''}`}
                            style={{
                                fontSize: "12px",
                                lineHeight: "15px",
                                textDecoration: "none",
                                padding: "7px 12px 7px 12px",
                                width: "56px",
                                height: "27px",
                                radius: "7px"
                            }}
                            onClick={()=> changeAccountView('grid')}>
                            {/* <img src='/img/icons/grid_grey.png' alt="image" className='filter_image' width=""/> */}
                            Card
                        </Link>
                    </div>

                    {/* <div className='filter_btn_block'>
                        <Button variant="primary" onClick={handleShow} className='filter_btn'>Filter <img src='/img/icons/arrowheads.png' alt="image" className='filter_image' width=""/> </Button>
                    </div> */}

                    {userCurrentRole === 'CLIENT' && 
                    <div className="align-right">
                        <Link
                            style={{
                                width: "128px",
                                height: "30px",
                                top: "20px",
                                radius: "8px",
                                // padding: "12px",
                                gap: "10px",
                                backgroundColor: "#232428",
                                weight: "600",
                                fontSize: "13px",
                                lineHeight: "16.25px",
                                color: "#FFFFFF"
                            }}
                            className="add_account_companies"
                            to="#"
                             onClick={modalAddAccount}
                            // onClick={() => setShowMoreModal(true)}
                        >
                        <FeatherIcon.Plus className='add_icon' />  Add Account
                        </Link>
                    </div>
                    }

                </div>
            </div>
            }

            {all_accounts_view === 'grid' && 
                <>
                {loading ? (
                    <GenericTableSkeleton colCount={7} rowCount={10} />
                ) : (
                    <AllAccountsTileView searchTerm={searchTerm} handleAccountPlanDownload={handleAccountPlanDownload} /> 
                ) }
                </>
            }

            {all_accounts_view === 'table' && 
                <>
                {loading ? (
                    <GenericTableSkeleton colCount={7} rowCount={10} />
                ) : (
                    <AllAccountsTableView searchTerm={searchTerm} handleAccountPlanDownload={handleAccountPlanDownload} />
                ) }
                </>
            }

            <Modal show={show} onHide={handleClose} className='custom_modal_filter' centered>
                <Modal.Header closeButton className='custom_modal_header'>
                    <Modal.Title>Filters</Modal.Title>
                </Modal.Header>
                <Modal.Body className='custom_modal_body'>
                    <div className='custom_filter_body'>
                        <div className='filter_block'>
                            <div className='filter_head'>
                            <FeatherIcon.Settings className='top_icons' /> Industry
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Oil & Gas Equipment</span>
                            </label>
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Retail Fuel Distribution</span>
                            </label>
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Natural Gas</span>
                            </label>
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Storage Facilities</span>
                            </label>
                            </div>
                            <div className='show_more_filters'>
                                <a href="#" className='link_show'><FeatherIcon.Plus className='plus_icon' />Show more</a>
                            </div>                
                        </div>
                        <div className='filter_block'>
                            <div className='filter_head'>
                            <FeatherIcon.PieChart className='top_icons' /> Relevance
                            </div>
                            <div className='checkbox_custom'>
                            <img src='/img/progess_bar.png' alt="image" className='chart_pie_icon' width=""/>
                            </div>                             
                        </div>
                        <div className='filter_block'>
                            <div className='filter_head'>
                            <FeatherIcon.DollarSign className='top_icons' /> Revenue
                            </div>
                            <div className='checkbox_custom'>
                            <img src='/img/progess_bar.png' alt="image" className='chart_pie_icon' width=""/>
                            </div>
                                    
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className='custom_modal_footer'>
                    <Button variant="link" onClick={handleClose} className='clearall'>
                        Clear All
                    </Button>
                    <Button variant="link" onClick={handleClose} className='applyfilter'>
                        Apply Filters
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showAddAccModal} onHide={handleAddAccClose} centered size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title>Add Account</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className='row'>
                    {addApiError && <div className="alert alert-danger">{addApiError}</div>}
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-12">
                        <label htmlFor="labelAccountName" className="form-label custom_label">Account Name <span className='red'>*</span> <span className=''><em>(Search among 3 crore+ companies)</em></span> </label> 
                            <Autocomplete
                            autocomplete_for="add_account"
                            name="account_name"
                            key="suggest_account_name"
                            value={newAccountName}
                            onChange={handleAutoCompleteChange}
                            placeholder="Account Name - Search among 3 crore+ companies"
                            element_field_key="account_name"
                            apiUrl="/company/search_company_advanced"
                            labelKey="companyname"
                            valueKey="companyid"/>
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-12">
                            <label htmlFor="labelAccountName" className="form-label custom_label">Website <span className='red'>*</span> </label>
                                <div className=''>
                                <input 
                                    disabled={isWebisteFieldDisabled}
                                    className='form-control form-field'
                                    type="text" 
                                    onChange={handleWebsiteChange} 
                                    value={newAccountWebsite.trim()}
                                    placeholder=''
                                    style={{
                                        color: "#686868 !important",
                                        border: "1px solid #d5d5d5 !important",
                                        borderRadius: 'none',
                                        padding: "5px 4px 6px !important"
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-12">
                            <AdditionalWebsitesInputElem setAdditionalWebisites={setAdditionalWebisites} />
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-12">
                            <label htmlFor="labelAccountName" className="form-label custom_label">Target Geographies <span className='red'>*</span> </label>
                                <div className='customGeoSelectDiv'>
                                {/* <Multiselect
                                    name="geographies"
                                    value={targetedRegions || []}
                                    options={regionsList.map((data) => ({
                                        id: data.Code,
                                        name: data.Name,
                                    }))}
                                    selectedValues={regionsList
                                        .filter((value) =>
                                        targetedRegions.includes(value)
                                        )
                                        .map((key, value) => ({
                                        id: key,
                                        name: value,
                                        }))}
                                    onSelect={(selectedList) => {
                                        handleRegionChange(selectedList)
                                        
                                    }}
                                    onRemove={(selectedList) => {
                                        handleRegionChange(selectedList)
                                    }}
                                    displayValue="name"
                                    showCheckbox={true}
                                    placeholder="Select Geography"
                                /> */}

                                {/* <Select
                                    className="custom_agentform_control font14"
                                    options={regionsList}
                                    defaultValue={regionsList.find(item => item.value === "ALL")} // example default
                                    onChange={(el) => {
                                        const selected = regionsList?.find(
                                            (item) => item.value === el.value && item.value != ""
                                        );
                                        handleRegionChange(selected)
                                    }}
                                    placeholder="Select Geography"
                                /> */}

                                <Select
                                    className="custom_agentform_control font14"
                                    options={regionsList}   // stays as Name & Code
                                    getOptionLabel={(option) => option.name}   // use Name for display
                                    getOptionValue={(option) => option.id}   // use Code for value
                                    // defaultValue={targetedRegions}
                                    value={targetedRegions}
                                    onChange={(selected) => handleRegionChange(selected)}  // selected has Name & Code
                                    placeholder="Select Geography"
                                />
                            </div>
                        </div>
                    </div>

                    {newAccountWebsite && <div className="row">
                        <div className={`col-md-12`}>
                            <div className='row'>
                                <div className={`${numberOfContacts < 100 ? 'alert alert-danger' : 'alert alert-success'} col-md-12 border-0 m-0 py-2 `} style={{
                                    backgroundColor: 'none', background: 'none'
                                }} >
                                    <label htmlFor="labelAccountName" className="form-label custom_label">Matched Contact Count : </label> 
                                    <span className={`ml-1 ${numberOfContacts < 100 ? 'red' : 'green' } `}>{numberWithCommas(numberOfContacts)}</span> 
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip
                                            id="contacts-text-tooltip"
                                            className="custom-use-case-tooltip"
                                            style={{ fontSize: '13px' }}
                                            >
                                            Contacts will be matched among these contacts. The number of generated contacts may vary based on ICP keywords
                                            </Tooltip>
                                        }
                                        >
                                        <span className='ml-2'>
                                            <FeatherIcon.Info size={16} ></FeatherIcon.Info>
                                        </span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    <div className="row">
                        <div className="col-md-12">
                            <label htmlFor="labelAccountName" className="form-label custom_label">Upload Memory Document </label>
                            {/* <input 
                                type="file" 
                                multiple 
                                onChange={handleFileChange} 
                                style={{
                                    display: "block",
                                    width: "100%",
                                    padding: "6px 10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    backgroundColor: "#f9f9f9",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    marginBottom: "10px",
                                }}
                                ref={fileInputRef} /> */}

                            <div
      onClick={() => fileInputRef.current?.click()} // Click to open file dialog
      style={{
        border: "2px dashed #ccc",
        borderRadius: "6px",
        padding: "20px",
        textAlign: "center",
        backgroundColor: "#f9f9f9",
        cursor: "pointer",
        fontSize: "14px",
        color: "#666",
        marginBottom: "10px",
      }}
      onDragOver={(e) => e.preventDefault()} // Allow drag over
      onDrop={(e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        handleFileChange({ target: { files: droppedFiles } });
      }}
    >
      <p style={{ margin: 0, fontWeight: 600 }}>
        Drag and drop files here or Click to Attach.
      </p>
      <input
        type="file"
        accept=".doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.pdf,.txt"
        multiple
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: "none" }} // Hide input
      />
    </div>

                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                            {accountMemoryFiles.map((fileObj, index) => (
                                <li
                                key={index}
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    padding: "6px 10px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    marginBottom: "5px",
                                    fontSize: "13px",
                                }}
                                >
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {fileObj.file.name}
                                    </span>
                                    <span
                                    className="red"
                                    onClick={() => handleRemoveFile(index)}
                                    style={{
                                        color: "#dc3545",
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                    >
                                    <FeatherIcon.Trash2 size={14} />
                                    </span>
                                </div>

                                {/* 🔹 Show error message if exists */}
                                {fileObj.error && (
                                    <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                    {fileObj.error}
                                    </div>
                                )}
                                </li>
                            ))}
                            </ul>

                        </div>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAddAccClose}>
                        Close
                    </Button>
                    <Button disabled={loader4AddingAccount} variant="danger" onClick={handleAddAccount}>
                      {loader4AddingAccount ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        <></>
                      )}{" "}  Submit
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
